// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar__title[data-v-d45f386a]{overflow:visible;display:flex}[data-v-d45f386a] .v-toolbar__content{padding:4px 0}", ""]);
// Exports
module.exports = exports;
